<template>
    <div>
        <div class="card-body">
            <div class="btn-toolbar justify-content-between mb-2" role="toolbar">
                <div class="col-w">

                </div>
                <div class="input-group">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <kendo-treelistdatasource ref="treelistdatasource"
                                      :transport="transportSettings"
                                      :schema-model-id="'id'"
                                      :schema-model="schemaModel"
                                      :schema-total="'count'"
                                      :schema-data="'items'"
                                      :page-size='defaultGridRows'
                                      :error="dataSourceError"
                                      :requestEnd="datasorceRequestEnd">
            </kendo-treelistdatasource>

            <kendo-treelist ref="treelist"
                            :data-source-ref="'treelistdatasource'"
                            :navigatable="gridOptions.navigatable"
                            :editable="editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="false"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :remove="itemDeletion"
                            :drop="itemDrop"
                            :toolbar="toolbar">
                <kendo-treelist-column :field="'id'"
                                       :title="$t('registers.nomenclatures.gridHeaders.id')"
                                       :width="100"
                                       :expandable="true">
                </kendo-treelist-column>
                <kendo-treelist-column :field="'parentModel'"
                                       :title="$t('registers.nomenclatures.gridHeaders.parentName')"
                                       :editor="parentIdDropDownEditor"
                                       :template="parentCellTemplate"
                                       :width="150"
                                       :filterable="false"
                                       :groupable="false"
                                       :sortable="false">
                </kendo-treelist-column>
                <kendo-treelist-column :field="'groupName'"
                                       :title="$t('registers.nomenclatures.gridHeaders.nameEn')"
                                       :width="200">
                </kendo-treelist-column>
                <kendo-treelist-column :field="'groupNameEn'"
                                       :title="$t('registers.nomenclatures.gridHeaders.nameEn')"
                                       :width="200">
                </kendo-treelist-column>
                <kendo-treelist-column :field="'description'"
                                       :title="$t('registers.nomenclatures.gridHeaders.description')"
                                       :width="200">
                </kendo-treelist-column>
                <kendo-treelist-column :field="'deactivated'"
                                       :title="$t('registers.nomenclatures.gridHeaders.deactivated')"
                                       :hidden="true"
                                       :width="150">
                </kendo-treelist-column>
                <!--<kendo-treelist-column :field="'deleted'"
                                       :template="deletedCellTemplate"
                                       :title="$t('registers.nomenclatures.gridHeaders.deleted')"
                                       :width="150">
                </kendo-treelist-column>-->
                <kendo-treelist-column :field="'active'"
                                       :template="activeCellTemplate"
                                       :title="$t('registers.nomenclatures.gridHeaders.active')"
                                       :width="150">
                </kendo-treelist-column>
                <kendo-treelist-column :command="command"
                                       :title="$t('actions')"
                                       :width="300">
                </kendo-treelist-column>
            </kendo-treelist>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import $ from 'jquery'; // това се изисква за да се вмъкват kendo ui компоненти. Виж метод parentIdDropDownEditor
    import { TreeViewInstaller } from '@progress/kendo-treeview-vue-wrapper'
    import { TreeListInstaller } from '@progress/kendo-treelist-vue-wrapper'
    import { mapGetters } from 'vuex'

    Vue.use(TreeViewInstaller)
    Vue.use(TreeListInstaller);


    export default {
        components: {

        },
        data: function () {
            return {
                activePrompt: false,
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModel: {
                    id: 'id',
                    parentId: 'parentId',
                    fields: {
                        id: { field: 'id', type: 'number', nullable: false, editable: false },
                        parentId: { field: 'parentId', type: 'number', nullable: true, editable: false },
                        level: { field: 'level', type: 'number', nullable: false, editable: false },
                        bc: { field: 'bc', type: 'string', nullable: false, editable: false },
                        hasChildren: { field: 'hasChildren', type: 'boolean', nullable: false, editable: false },
                        branchNum: { field: 'branchNum', type: 'number', nullable: true, editable: false },
                        branchName: { field: 'branchName', type: 'string', nullable: true, editable: false },
                        parentName: { field: 'parentName', type: 'string', nullable: true, editable: false },
                        parentNameEn: { field: 'parentNameEn', type: 'string', nullable: true, editable: false },
                        parentSort: { field: 'parentSort', type: 'number', nullable: true, editable: false },
                        groupName: { field: 'groupName', type: 'string', nullable: false, editable: true, validation: { required: true } },
                        groupNameEn: { field: 'groupNameEn', type: 'string', nullable: false, editable: true, validation: { required: true } },
                        description: { field: 'description', type: 'string', nullable: true, editable: true },
                        sort: { field: 'sort', type: 'number', nullable: true, editable: true },
                        deactivated: { field: 'deactivated', type: 'boolean', nullable: false, editable: true, visible: false },
                        updated: { field: 'updated', type: 'boolean', nullable: false, editable: false },
                        deleted: { field: 'deleted', type: 'boolean', nullable: false, editable: false },
                        parentModel: { defaultValue: { id: 0, text: 'Избери...', textEx: 'Select...' } },
                        active: { field: 'active', type: 'boolean', nullable: false, editable: false, visible: true },
                    },
                    expanded: true
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/tariffs/listGroups',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    create: {
                        url: this.$store.getters.baseUrl + '/api/tariffs/createGroup',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: this.$store.getters.baseUrl + '/api/tariffs/updateGroup',
                        dataType: 'json',
                        type: 'PUT',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                editable: {
                    mode: 'popup',
                    window: {
                        title: this.$t('finance.pageTitle'),
                        animation: true
                    },
                    move: true
                }
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    return kendo.stringify(options);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            datasorceRequestEnd(e) {
                if (e.type === "create" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type === "update" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type === "destroy" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            parentCellTemplate: function (dataItem) {
                if (dataItem.parentModel === null) {
                    return kendo.htmlEncode("");
                }

                if (dataItem.parentModel.text === null && dataItem.parentModel.textEn === null) {
                    return kendo.htmlEncode("");
                }

                let templateHtml = '<span>' + kendo.htmlEncode(this.isEnVersion ? dataItem.parentModel.textEn : dataItem.parentModel.text) + '</span>';

                return templateHtml;
            },
            parentIdDropDownEditor: function (container, options) {
                $('<input name="' + options.field + '"/> id="' + options.field + '"')
                    .appendTo(container)
                    .kendoDropDownList({
                        autoBind: false,
                        dataTextField: this.isEnVersion ? 'textEn' : 'text',
                        dataValueField: "id",
                        optionLabel: this.$t('selectTariffGroup'),
                        dataSource: {
                            transport: {
                                read: {
                                    url: this.$store.getters.baseUrl + '/api/tariffs/groupParents',
                                    dataType: 'json',
                                    type: 'GET',
                                    contentType: 'application/json',
                                    beforeSend: this.beforeSend
                                },
                            },
                            requestEnd: this.dropDownEditorDatasorceRequestEnd(options)
                        }
                    });
            },
            dropDownEditorDatasorceRequestEnd(options) {

            },
            deletedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deleted ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deleted ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            itemDrop(e) {
                if (e.valid) {
                    e.preventDefault();
                    if (!e.source) {
                        this.$vs.notify({
                            title: this.$t('400'),
                            text: this.$t('invalidAction') + ' ' + this.$t('missingSource'),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                        return;
                    }

                    if (e.destination === null || e.destination === undefined) {
                        // Мести се като главна група
                        kendo.confirm('Сигурни ли сте, че искате да направите "' + e.source.groupName
                            + '" главна група?').then(function () {
                                if (e.source.parentId) {
                                    e.source.parentId = null;
                                    this.moveGroup(e.source.id, null, e.sender);
                                }
                            }.bind(this));
                    } else {
                        kendo.confirm('Сигурни ли сте, че искате да преместите "' + e.source.groupName
                            + '" в група "' + e.destination.groupName + '"?').then(function () {
                                if (e.source && e.destination.id) {
                                    e.source.parentId = e.destination.id;
                                    this.moveGroup(e.source.id, e.destination.id, e.sender);
                                }
                            }.bind(this));
                    }
                }
            },
            itemDeletion(e) {
                if (e.model) {
                    e.preventDefault();
                    let model = e.model;
                    kendo.confirm("Сигурни ли сте, че искате да изтриете група " + model.groupName + "?")
                        .then(function () {
                            this.deleteGroup(model.id);
                        }.bind(this));
                }
            },
            deleteGroup(id) {
                this.$http.delete('/api/tariffs/deleteGroup',
                    { params: { id: id } }
                ).then((response) => {
                    this.$refs.treelist.kendoWidget().dataSource.read();
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            moveGroup(id, parentId, sender) {
                this.$http.put('/api/tariffs/moveGroup', { id: id, parentId: parentId }
                ).then((response) => {
                    sender.refresh();

                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.treelist.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let treelist = this.$refs.treelist.kendoWidget();
                if (treelist) {
                    let filter = this.$helpers.getMassFilterForGrid(treelist, this.searchQuery);
                    if (filter) {
                        treelist.dataSource.filter(filter);
                    }
                }
            },
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            toolbar: function () {
                if (this.hasCreateRights) {
                    return [{ name: 'create', text: this.$t('buttons.create.btnText') }]
                } else {
                    return [];
                }
            },
            command: function () {
                let cmd = [];
                if (this.hasUpdateRights) {
                    cmd.push({ name: 'edit', text: this.$t('buttons.edit.btnText') });
                }
                if (this.hasDeleteRights) {
                    cmd.push({ name: 'destroy', text: this.$t('buttons.delete.tooltipText') });
                }

                return cmd;
            },
            hasReadRights() {
                return this.$store.getters.claims.tariff.read;
            },
            hasCreateRights() {
                return this.$store.getters.claims.tariff.create;
            },
            hasUpdateRights() {
                return this.$store.getters.claims.tariff.update;
            },
            hasDeleteRights() {
                return this.$store.getters.claims.tariff.delete;
            },
        }
    }
</script>
